import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AppViewChord } from '../view/Chord';
import { AppViewChords } from '../view/Chords';
import { AppViewChordsteps } from '../view/Chordsteps';
import { AppViewError } from '../view/Error';
import { AppViewIndex } from '../view/Index';
import { AppViewSong } from '../view/Song';
import { AppViewSongs } from '../view/Songs';

const routes: Routes = [
  {
    path: '', component: AppViewIndex, children: [
      { path: 'chords', component: AppViewChords },
      { path: 'chords/:note', component: AppViewChord },
      { path: 'chordsteps', component: AppViewChordsteps },
      { path: 'chordsteps/:note', component: AppViewChord },
      { path: 'songs', component: AppViewSongs },
      { path: 'songs/:artist', component: AppViewSongs },
      { path: 'songs/:artist/:title', component: AppViewSong }
    ]
  },
  { path: '**', component: AppViewError }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
